var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhlebotomyWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.37188 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12C24 18.6281 18.6281 24 12 24ZM12 15C11.1703 15 10.5 15.6703 10.5 16.5C10.5 17.3297 11.1703 18 12 18C12.8297 18 13.5 17.3297 13.5 16.5C13.5 15.6703 12.8297 15 12 15ZM12 6C11.1469 6 10.4672 6.72656 10.5281 7.57969L10.875 12.4547C10.9172 13.0453 11.4094 13.5 11.9953 13.5C12.5859 13.5 13.0734 13.0453 13.1156 12.4547L13.4625 7.57969C13.5234 6.72656 12.8484 6 11.9906 6H12Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhlebotomyWarning);
export default __webpack_public_path__ + "static/media/phlebotomy-warning.8d0b20b35f18388f2a359ffcdbe35f35.svg";
export { ForwardRef as ReactComponent };